import { AutogiroMandateResponse } from 'src/modules/invoice/models/autogiroMandateResponse';
import { AutogiroSearchFilter } from 'src/modules/invoice/models/autogiroSearchFilter';
import { AutogiroMandatePostRequest } from 'src/modules/invoice/models/autogiroMandatePostRequest';
import { AutogiroMandatePutRequest } from 'src/modules/invoice/models/autogiroMandatePutRequest';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'AutogiroMandate';

export const getAllAutogiroMandate = (searchFilter: AutogiroSearchFilter) => {
  return AxiosInstance.get<PagedResult<AutogiroMandateResponse>>(controller, { params: searchFilter });
};

export const getAutogiroMandateById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<AutogiroMandateResponse>(endpoint);
};

export const cancelAutogiroMandate = (autogiroId: number) => {
  const endpoint = `${controller}/${autogiroId}/Cancel`;
  return AxiosInstance.put<number>(endpoint, autogiroId);
};

export const createAutogiroMandateFile = (invoiceGroup: number, mandateIds: number[]) => {
  const endpoint = `${controller}/CreateFile?ownerId=${invoiceGroup}`;
  return AxiosInstance.put<number>(endpoint, mandateIds);
};

export const createAutogiroMandate = (data: AutogiroMandatePostRequest) => {
  return AxiosInstance.post<AutogiroMandatePostRequest>(controller, data);
};

export const updateAutogiroMandate = (data: AutogiroMandatePutRequest) => {
  return AxiosInstance.put<AutogiroMandatePutRequest>(controller, data);
};

export const deleteAutogiroMandate = (autogiroMandateId: number) => {
  const endpoint = `${controller}/${autogiroMandateId}`;
  return AxiosInstance.delete<number>(endpoint);
};
